import SelectionChip from '@/components/Select/SelectionChips/SelectionChip';
import FilterGroupChip from '@/components/Select/SelectionChips/SelectionGroupChip';
import { useMemo } from 'react';

interface IProps {
  value?: string[];
  limitTags?: number;
}

const EmailsCell = ({ value, limitTags = 3 }: IProps) => {
  const visibleEmails = useMemo(() => value?.slice(0, limitTags), [limitTags, value]);
  if (!value?.length) return null;

  return (
    <div className='flex gap-1 flex-nowrap' role='presentation' title={value.join(', ')}>
      {visibleEmails!.map((email, i) => (
        <SelectionChip key={i} label={email} />
      ))}
      {limitTags < value.length ? <FilterGroupChip items={value.slice(limitTags)} /> : null}
    </div>
  );
};

export default EmailsCell;
